import axios from "axios";
import { AUTH_TOKEN } from "../utils/common";

const apiClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
});

const successResponseInterceptor = (response) => {
  return response?.data?.data;
};

const errorResponseInterceptor = (error) => {
  console.log(error?.response);
};

const requestInterceptor = (req) => {
  const token = localStorage.getItem(AUTH_TOKEN) || "";
  req.headers.Authorization = `Bearer ${token}`;
  return req;
};

apiClient.interceptors.request.use(requestInterceptor);
apiClient.interceptors.response.use(successResponseInterceptor, errorResponseInterceptor);

export default apiClient;
